import gql from 'graphql-tag'


export const GLAMSQUADS = gql`
    query userGlamSquadMembers($userId: String) {
        userGlamSquadMembers(userId: $userId) {
            id
            comment testimony
            member{ id firstName lastName avatar profile { nickName }}
         
        }
    }
`

export const CREATE_GLAMSQUAD_MEMBER = gql`
 query createUserGlamSquadMember($data: UserGlamSquadMemberInput) {
    createUserGlamSquadMember(data: $data) {
        id
        comment testimony
        member{ id firstName lastName}
       
    }
 }
`

export const UPDATE_GLAMSQUAD_MEMBER = gql`
 query updateUserGlamSquadMember($data: UserGlamSquadMemberInput) {
    updateUserGlamSquadMember(data: $data) {
        id
        comment testimony
        member{ id firstName lastName}
       
    }
 }
`

export const DELETE_GLAMSQUAD_MEMBER = gql`
 mutation deleteRoutine($id: String!) {
    deleteRoutine(id: $id)
 }
`

